export default "/assets/images/caught-me-cleaning.f907ad9313dc1822.webp";